const moment = require('moment')

function fillMonth (stdData) {
  for (const sex of ['1', '2']) {
    let curStds
    for (let i = 0; i < 84; i++) {
      if (stdData[sex][i]) {
        curStds = stdData[sex][i]
      } else {
        stdData[sex][i] = curStds
      }
    }
  }
  return stdData
}

const bmiStd = fillMonth({
  1: {
    0: [10.2, 11.1, 12.1, 13.2, 14.4, 15.7, 17.1],
    1: [11.8, 12.9, 14.0, 15.1, 16.4, 17.7, 19.2],
    2: [13.1, 14.2, 15.4, 16.7, 18.1, 19.7, 21.4],
    3: [13.6, 14.8, 16.0, 17.4, 19.0, 20.8, 22.7],
    4: [13.9, 15.0, 16.3, 17.8, 19.4, 21.2, 23.3],
    5: [14.0, 15.1, 16.4, 17.9, 19.5, 21.4, 23.5],
    6: [14.1, 15.2, 16.4, 17.9, 19.5, 21.4, 23.5],
    7: [14.1, 15.2, 16.4, 17.8, 19.4, 21.3, 23.4],
    8: [14.1, 15.1, 16.3, 17.7, 19.3, 21.1, 23.2],
    9: [14.0, 15.1, 16.2, 17.6, 19.1, 20.9, 23.0],
    10: [14.0, 15.0, 16.1, 17.5, 19.0, 20.7, 22.8],
    11: [13.9, 14.9, 16.0, 17.3, 18.8, 20.5, 22.6],
    12: [13.8, 14.8, 15.9, 17.1, 18.6, 20.3, 22.3],
    13: [13.7, 14.7, 15.7, 17.0, 18.4, 20.1, 22.1],
    14: [13.6, 14.6, 15.6, 16.8, 18.3, 19.9, 21.9],
    15: [13.5, 14.5, 15.5, 16.7, 18.1, 19.7, 21.7],
    16: [13.5, 14.4, 15.4, 16.6, 18.0, 19.6, 21.5],
    17: [13.4, 14.3, 15.3, 16.5, 17.8, 19.4, 21.4],
    18: [13.3, 14.2, 15.2, 16.4, 17.7, 19.3, 21.2],
    19: [13.3, 14.1, 15.1, 16.3, 17.6, 19.2, 21.1],
    20: [13.2, 14.1, 15.0, 16.2, 17.5, 19.1, 21.0],
    21: [13.2, 14.0, 15.0, 16.1, 17.4, 19.0, 20.9],
    22: [13.1, 13.9, 14.9, 16.0, 17.3, 18.9, 20.8],
    23: [13.0, 13.9, 14.8, 15.9, 17.2, 18.8, 20.7],
    24: [13.2, 14.0, 15.0, 16.1, 17.4, 19.0, 20.9],
    27: [13.1, 13.9, 14.8, 15.9, 17.2, 18.8, 20.7],
    30: [12.9, 13.7, 14.7, 15.8, 17.0, 18.6, 20.4],
    33: [12.9, 13.6, 14.6, 15.6, 16.9, 18.4, 20.3],
    36: [12.8, 13.6, 14.5, 15.5, 16.8, 18.3, 20.1],
    39: [12.7, 13.5, 14.4, 15.4, 16.7, 18.2, 20.1],
    42: [12.7, 13.4, 14.3, 15.4, 16.6, 18.1, 20.0],
    45: [12.6, 13.4, 14.3, 15.3, 16.6, 18.1, 20.0],
    48: [12.6, 13.3, 14.2, 15.3, 16.6, 18.1, 20.1],
    51: [12.5, 13.3, 14.2, 15.3, 16.6, 18.2, 20.2],
    54: [12.5, 13.3, 14.2, 15.3, 16.6, 18.2, 20.3],
    57: [12.4, 13.2, 14.1, 15.3, 16.6, 18.3, 20.5],
    60: [12.4, 13.2, 14.1, 15.3, 16.7, 18.4, 20.7],
    63: [12.3, 13.1, 14.1, 15.3, 16.7, 18.6, 21.0],
    66: [12.3, 13.1, 14.1, 15.3, 16.8, 18.7, 21.4],
    69: [12.2, 13.1, 14.1, 15.3, 16.9, 18.9, 21.7],
    72: [12.2, 13.1, 14.1, 15.4, 17.0, 19.1, 22.1],
    75: [12.2, 13.0, 14.1, 15.4, 17.1, 19.3, 22.5],
    78: [12.1, 13.0, 14.1, 15.4, 17.2, 19.5, 22.9],
    81: [12.1, 13.0, 14.1, 15.4, 17.2, 19.7, 23.3]
  },
  2: {
    0: [10.0, 10.9, 12.0, 13.1, 14.2, 15.4, 16.7],
    1: [11.7, 12.6, 13.5, 14.7, 15.9, 17.3, 18.9],
    2: [12.7, 13.7, 14.8, 16.1, 17.5, 19.1, 20.9],
    3: [13.2, 14.3, 15.4, 16.7, 18.3, 20.0, 22.0],
    4: [13.5, 14.6, 15.7, 17.1, 18.6, 20.5, 22.6],
    5: [13.7, 14.7, 15.9, 17.3, 18.8, 20.7, 22.9],
    6: [13.7, 14.8, 15.9, 17.3, 18.9, 20.8, 23.0],
    7: [13.7, 14.8, 15.9, 17.3, 18.9, 20.7, 22.9],
    8: [13.7, 14.7, 15.9, 17.2, 18.8, 20.6, 22.8],
    9: [13.7, 14.6, 15.8, 17.1, 18.6, 20.4, 22.5],
    10: [13.6, 14.6, 15.7, 17.0, 18.4, 20.2, 22.3],
    11: [13.5, 14.5, 15.6, 16.8, 18.3, 20.0, 22.0],
    12: [13.4, 14.4, 15.4, 16.7, 18.1, 19.8, 21.8],
    13: [13.4, 14.3, 15.3, 16.5, 17.9, 19.6, 21.6],
    14: [13.3, 14.2, 15.2, 16.4, 17.8, 19.4, 21.3],
    15: [13.2, 14.1, 15.1, 16.3, 17.6, 19.2, 21.1],
    16: [13.1, 14.0, 15.0, 16.2, 17.5, 19.1, 21.0],
    17: [13.1, 13.9, 14.9, 16.0, 17.4, 18.9, 20.8],
    18: [13.0, 13.8, 14.8, 15.9, 17.3, 18.8, 20.7],
    19: [12.9, 13.8, 14.7, 15.9, 17.2, 18.7, 20.5],
    20: [12.9, 13.7, 14.7, 15.8, 17.1, 18.6, 20.4],
    21: [12.8, 13.7, 14.6, 15.7, 17.0, 18.5, 20.3],
    22: [12.8, 13.6, 14.5, 15.6, 16.9, 18.4, 20.2],
    23: [12.7, 13.5, 14.5, 15.6, 16.8, 18.3, 20.1],
    24: [12.9, 13.7, 14.7, 15.8, 17.0, 18.6, 20.4],
    27: [12.8, 13.6, 14.5, 15.6, 16.9, 18.4, 20.2],
    30: [12.6, 13.5, 14.4, 15.5, 16.7, 18.2, 20.1],
    33: [12.6, 13.4, 14.3, 15.4, 16.6, 18.1, 20.0],
    36: [12.5, 13.3, 14.2, 15.3, 16.5, 18.1, 19.9],
    39: [12.4, 13.2, 14.1, 15.2, 16.5, 18.0, 19.9],
    42: [12.4, 13.2, 14.1, 15.2, 16.5, 18.0, 19.9],
    45: [12.3, 13.1, 14.0, 15.1, 16.4, 18.0, 20.0],
    48: [12.2, 13.0, 14.0, 15.1, 16.4, 18.0, 20.0],
    51: [12.2, 13.0, 13.9, 15.0, 16.4, 18.0, 20.1],
    54: [12.1, 12.9, 13.9, 15.0, 16.4, 18.1, 20.2],
    57: [12.1, 12.9, 13.9, 15.0, 16.4, 18.1, 20.3],
    60: [12.0, 12.9, 13.8, 15.0, 16.4, 18.2, 20.5],
    63: [12.0, 12.8, 13.8, 15.0, 16.4, 18.3, 20.6],
    66: [11.9, 12.8, 13.8, 15.0, 16.5, 18.4, 20.8],
    69: [11.9, 12.8, 13.8, 15.0, 16.5, 18.4, 21.0],
    72: [11.9, 12.7, 13.8, 15.0, 16.6, 18.5, 21.2],
    75: [11.9, 12.7, 13.8, 15.0, 16.6, 18.6, 21.4],
    78: [11.8, 12.7, 13.8, 15.0, 16.6, 18.7, 21.5],
    81: [11.8, 12.7, 13.8, 15.0, 16.7, 18.8, 21.7]
  }
})

const heightStd = fillMonth({
  1: {
    0: [45.4, 47.3, 49.2, 51.2, 53.1, 55.0, 56.9],
    1: [49.1, 51.1, 53.1, 55.1, 57.2, 59.2, 61.2],
    2: [52.6, 54.7, 56.8, 59.0, 61.1, 63.2, 65.4],
    3: [55.5, 57.8, 60.0, 62.2, 64.4, 66.6, 68.9],
    4: [58.0, 60.3, 62.5, 64.8, 67.1, 69.4, 71.7],
    5: [59.9, 62.3, 64.6, 66.9, 69.3, 71.6, 74.0],
    6: [61.6, 64.0, 66.3, 68.7, 71.1, 73.5, 75.9],
    7: [63.0, 65.4, 67.9, 70.3, 72.7, 75.1, 77.6],
    8: [64.3, 66.8, 69.3, 71.7, 74.2, 76.7, 79.1],
    9: [65.5, 68.0, 70.5, 73.1, 75.6, 78.1, 80.6],
    10: [66.7, 69.2, 71.8, 74.3, 76.9, 79.4, 82.0],
    11: [67.8, 70.3, 72.9, 75.5, 78.1, 80.7, 83.3],
    12: [68.8, 71.4, 74.1, 76.7, 79.3, 81.9, 84.6],
    13: [69.8, 72.5, 75.1, 77.8, 80.5, 83.1, 85.8],
    14: [70.8, 73.5, 76.2, 78.9, 81.6, 84.3, 87.0],
    15: [71.7, 74.5, 77.2, 80.0, 82.7, 85.5, 88.2],
    16: [72.7, 75.5, 78.2, 81.0, 83.8, 86.6, 89.4],
    17: [73.6, 76.4, 79.2, 82.1, 84.9, 87.7, 90.5],
    18: [74.5, 77.4, 80.2, 83.1, 86.0, 88.8, 91.7],
    19: [75.4, 78.3, 81.2, 84.1, 87.0, 89.9, 92.8],
    20: [76.3, 79.2, 82.2, 85.1, 88.0, 91.0, 93.9],
    21: [77.1, 80.1, 83.1, 86.1, 89.1, 92.0, 95.0],
    22: [78.0, 81.0, 84.0, 87.0, 90.1, 93.1, 96.1],
    23: [78.8, 81.9, 84.9, 88.0, 91.0, 94.1, 97.2],
    24: [78.9, 82.0, 85.1, 88.2, 91.3, 94.4, 97.5],
    27: [81.2, 84.4, 87.6, 90.8, 94.0, 97.2, 100.4],
    30: [83.3, 86.6, 89.9, 93.2, 96.5, 99.8, 103.1],
    33: [85.2, 88.6, 92.0, 95.4, 98.8, 102.2, 105.6],
    36: [87.0, 90.5, 94.0, 97.5, 101.0, 104.5, 108.0],
    39: [88.6, 92.2, 95.9, 99.5, 103.1, 106.7, 110.3],
    42: [90.3, 93.9, 97.6, 101.3, 105.0, 108.7, 112.4],
    45: [91.8, 95.6, 99.4, 103.1, 106.9, 110.7, 114.5],
    48: [93.3, 97.2, 101.0, 104.9, 108.8, 112.6, 116.5],
    51: [94.8, 98.8, 102.7, 106.6, 110.6, 114.5, 118.5],
    54: [96.3, 100.3, 104.4, 108.4, 112.4, 116.5, 120.5],
    57: [97.8, 102.0, 106.1, 110.2, 114.3, 118.4, 122.5],
    60: [99.4, 103.6, 107.8, 112.0, 116.2, 120.4, 124.6],
    63: [100.9, 105.2, 109.5, 113.7, 118.0, 122.3, 126.6],
    66: [102.3, 106.7, 111.1, 115.5, 119.8, 124.2, 128.6],
    69: [103.8, 108.2, 112.7, 117.1, 121.6, 126.1, 130.5],
    72: [105.2, 109.7, 114.3, 118.8, 123.3, 127.9, 132.4],
    75: [106.5, 111.2, 115.8, 120.4, 125.0, 129.7, 134.3],
    78: [107.9, 112.6, 117.3, 122.0, 126.7, 131.4, 136.1],
    81: [109.2, 113.9, 118.7, 123.5, 128.3, 133.1, 137.9]
  },
  2: {
    0: [44.7, 46.6, 48.4, 50.3, 52.2, 54.1, 55.9],
    1: [48.2, 50.1, 52.1, 54.1, 56.1, 58.1, 60.0],
    2: [51.5, 53.5, 55.6, 57.7, 59.8, 61.9, 63.9],
    3: [54.3, 56.4, 58.6, 60.8, 62.9, 65.1, 67.2],
    4: [56.6, 58.8, 61.0, 63.3, 65.5, 67.7, 69.9],
    5: [58.5, 60.7, 63.0, 65.3, 67.6, 69.9, 72.2],
    6: [60.1, 62.4, 64.7, 67.1, 69.4, 71.7, 74.1],
    7: [61.5, 63.9, 66.3, 68.7, 71.0, 73.4, 75.8],
    8: [62.8, 65.3, 67.7, 70.1, 72.5, 75.0, 77.4],
    9: [64.1, 66.5, 69.0, 71.5, 73.9, 76.4, 78.9],
    10: [65.3, 67.8, 70.3, 72.8, 75.3, 77.8, 80.3],
    11: [66.4, 68.9, 71.5, 74.0, 76.6, 79.1, 81.7],
    12: [67.5, 70.1, 72.6, 75.2, 77.8, 80.4, 83.0],
    13: [68.5, 71.1, 73.8, 76.4, 79.0, 81.7, 84.3],
    14: [69.5, 72.2, 74.9, 77.5, 80.2, 82.9, 85.6],
    15: [70.5, 73.2, 75.9, 78.6, 81.4, 84.1, 86.8],
    16: [71.5, 74.2, 77.0, 79.7, 82.5, 85.2, 88.0],
    17: [72.4, 75.2, 78.0, 80.8, 83.6, 86.4, 89.2],
    18: [73.3, 76.2, 79.0, 81.9, 84.7, 87.5, 90.4],
    19: [74.3, 77.1, 80.0, 82.9, 85.8, 88.6, 91.5],
    20: [75.1, 78.1, 81.0, 83.9, 86.8, 89.7, 92.6],
    21: [76.0, 79.0, 81.9, 84.9, 87.8, 90.8, 93.7],
    22: [76.9, 79.9, 82.8, 85.8, 88.8, 91.8, 94.8],
    23: [77.7, 80.7, 83.7, 86.8, 89.8, 92.8, 95.9],
    24: [77.8, 80.8, 83.9, 87.0, 90.1, 93.1, 96.2],
    27: [80.0, 83.2, 86.4, 89.5, 92.7, 95.9, 99.1],
    30: [82.1, 85.3, 88.6, 91.9, 95.2, 98.5, 101.7],
    33: [84.0, 87.3, 90.7, 94.1, 97.5, 100.9, 104.2],
    36: [85.8, 89.3, 92.7, 96.2, 99.7, 103.2, 106.6],
    39: [87.5, 91.1, 94.6, 98.2, 101.8, 105.3, 108.9],
    42: [89.1, 92.8, 96.4, 100.1, 103.7, 107.4, 111.0],
    45: [90.7, 94.4, 98.2, 101.9, 105.6, 109.4, 113.1],
    48: [92.2, 96.0, 99.8, 103.7, 107.5, 111.3, 115.1],
    51: [93.7, 97.6, 101.5, 105.4, 109.3, 113.2, 117.2],
    54: [95.2, 99.2, 103.2, 107.2, 111.2, 115.2, 119.2],
    57: [96.8, 100.8, 104.9, 109.0, 113.1, 117.2, 121.2],
    60: [98.3, 102.5, 106.6, 110.8, 115.0, 119.1, 123.3],
    63: [99.8, 104.1, 108.3, 112.6, 116.8, 121.1, 125.3],
    66: [101.2, 105.6, 109.9, 114.3, 118.6, 123.0, 127.3],
    69: [102.6, 107.1, 111.5, 115.9, 120.4, 124.8, 129.2],
    72: [104.0, 108.5, 113.0, 117.5, 122.0, 126.5, 131.0],
    75: [105.3, 109.9, 114.5, 119.1, 123.7, 128.2, 132.8],
    78: [106.6, 111.3, 115.9, 120.6, 125.3, 129.9, 134.6],
    81: [107.9, 112.6, 117.3, 122.1, 126.8, 131.6, 136.3]
  }
})

export function getBMILevel (sex, birthday, date, bmi) {
  const month = moment(date).diff(birthday, 'months')
  const std = bmiStd[sex][month]

  if (!std) return '-'

  // <-3 SD
  if (bmi < std[0]) {
    return '重度消瘦'
  }
  // -3 SD≤ • <-2 SD
  if (bmi >= std[0] && bmi < std[1]) {
    return '消瘦'
  }
  // +1 SD≤ • <+2 SD
  if (bmi >= std[4] && bmi < std[5]) {
    return '超重'
  }
  // +2 SD≤ • <+3 SD
  if (bmi >= std[5] && bmi < std[6]) {
    return '肥胖'
  }
  // ≥+3 SD
  if (bmi >= std[6]) {
    return '重度肥胖'
  }
  return ''
}

export function getCommonBMIRange (sex, birthday, date) {
  const month = moment(date).diff(birthday, 'months')
  const std = bmiStd[sex][month]

  if (!std) return
  return [std[1], std[4], std[5]]
}

export function getHeightLevel (sex, birthday, date, height) {
  const month = moment(date).diff(birthday, 'months')
  const std = heightStd[sex][month]
  if (!std) return '-'

  // <-3 SD
  if (height < std[0]) {
    return '重度生长迟缓'
  }
  // -3 SD≤ • <-2 SD
  if (height >= std[0] && height < std[1]) {
    return '生长迟缓'
  }

  return ''
}

export function getCommonHeightLow (sex, birthday, date) {
  const month = moment(date).diff(birthday, 'months')
  const std = heightStd[sex][month]

  if (!std) return
  return std[1]
}

export function getBmiBorders (sex, age, pregnancyWeek) {
  if (pregnancyWeek > 0) {
    // 孕期
    return [18.5, 24, 28]
  }
  if (sex === '2') {
    switch (age) {
      case undefined:
        return [17.2, 24, 28]
      case 1:
        return [11.2, 11.38, 12.09]
      case 1.5:
        return [11.5, 11.84, 12.62]
      case 2:
        return [12.1, 12.29, 13.15]
      case 2.5:
        return [12.5, 12.75, 13.68]
      case 3:
        return [13.1, 13.2, 14.2]
      case 3.5:
        return [13.0, 13.66, 14.73]
      case 4:
        return [13.1, 14.11, 15.26]
      case 4.5:
        return [13.2, 14.56, 15.79]
      case 5:
        return [13.3, 15.02, 16.32]
      case 5.5:
        return [13.1, 15.47, 16.85]
      case 6:
        return [13.1, 16.2, 17.5]
      case 6.5:
        return [13.1, 16.5, 18]
      case 7:
        return [13.2, 16.8, 18.5]
      case 7.5:
        return [13.3, 17.2, 19]
      case 8:
        return [13.4, 17.6, 19.4]
      case 8.5:
        return [13.5, 18.1, 19.9]
      case 9:
        return [13.7, 18.5, 20.4]
      case 9.5:
        return [13.9, 19, 21]
      case 10:
        return [14.1, 19.5, 21.5]
      case 10.5:
        return [14.4, 20, 22.1]
      case 11:
        return [14.6, 20.5, 22.7]
      case 11.5:
        return [14.9, 21.1, 23.3]
      case 12:
        return [15.2, 21.5, 23.9]
      case 12.5:
        return [15.5, 21.9, 24.5]
      case 13:
        return [15.8, 22.2, 25]
      case 13.5:
        return [16, 22.6, 25.6]
      case 14:
        return [16.3, 22.8, 25.9]
      case 14.5:
        return [16.5, 23, 26.3]
      case 15:
        return [16.7, 23.2, 26.6]
      case 15.5:
        return [16.8, 23.4, 26.9]
      case 16:
        return [16.9, 23.6, 27.1]
      case 16.5:
        return [17, 23.7, 27.4]
      case 17:
        return [17.1, 23.8, 27.6]
      case 17.5:
        return [17.1, 23.9, 27.8]
      default:
        return [17.2, 24, 28]
    }
  }
  if (sex === '1') {
    switch (age) {
      case undefined:
        return []
      case 1:
        return [12.4, 12.76, 12.23]
      case 1.5:
        return [13.3, 13.12, 12.77]
      case 2:
        return [13.2, 13.48, 13.3]
      case 2.5:
        return [13.2, 13.84, 13.84]
      case 3:
        return [13.1, 14.2, 14.38]
      case 3.5:
        return [13.0, 14.55, 14.92]
      case 4:
        return [13.1, 14.91, 15.46]
      case 4.5:
        return [13.2, 15.27, 15.99]
      case 5:
        return [13.3, 15.63, 16.53]
      case 5.5:
        return [14.1, 15.99, 17.07]
      case 6:
        return [13.4, 16.4, 17.7]
      case 6.5:
        return [13.5, 16.7, 18.1]
      case 7:
        return [13.6, 17, 18.7]
      case 7.5:
        return [13.7, 17.4, 19.2]
      case 8:
        return [13.8, 17.8, 19.7]
      case 8.5:
        return [13.9, 18.1, 20.3]
      case 9:
        return [14.0, 18.5, 20.8]
      case 9.5:
        return [14.2, 18.9, 21.4]
      case 10:
        return [14.3, 19.2, 21.9]
      case 10.5:
        return [14.5, 19.6, 22.5]
      case 11:
        return [14.7, 19.9, 23]
      case 11.5:
        return [14.9, 20.3, 23.6]
      case 12:
        return [15.1, 20.7, 24.1]
      case 12.5:
        return [15.4, 21, 24.7]
      case 13:
        return [15.7, 21.4, 25.2]
      case 13.5:
        return [16.0, 21.9, 25.7]
      case 14:
        return [16.3, 22.3, 26.1]
      case 14.5:
        return [16.5, 22.6, 26.4]
      case 15:
        return [16.8, 22.9, 26.6]
      case 15.5:
        return [17.0, 23.1, 26.9]
      case 16:
        return [17.3, 23.3, 27.1]
      case 16.5:
        return [17.5, 23.5, 27.4]
      case 17:
        return [17.7, 23.7, 27.6]
      case 17.5:
        return [17.9, 23.8, 27.8]
      default:
        return [18.1, 24, 28]
    }
  }
  return [17.2, 24, 28]
}
